import cookie from './../utils/rbmc.cookie-utils';
import personalizeService from '../utils/rbmc.personalizeService';

const countryRedirect = {
    init() {
        let countryRedirectModal = $('.country-redirect-modal'),
            redirectDenied       = cookie.readCookie('REDIRECT_DENIED');

        personalizeService.getPersonalizedData().then((data) => {
            let geoIp = data.countryFromCookie;
            $.each(countryRedirectModal, function (i, modal) {
                let $modal = $(modal);
                if ($modal.data('country') === geoIp && redirectDenied === null) {
                    $modal.modal({
                        backdrop: 'static',
                        keyboard: false
                    });
                    $modal.modal('show');
                    countryRedirect.bindModalActionEvents($modal, $modal.data('country'));
                }
            });
        });
    },

    bindModalActionEvents($modal, countryCode) {
        $modal.find('.btn-stay').on('click', function () {
            countryRedirect.denySiteCountryRedirect($modal)
        });
        $modal.find('.btn-redirect').on('click', function () {
            countryRedirect.setSiteCountryRedirect(countryCode)
        });
    },

    setSiteCountryRedirect(countryCode) {
        cookie.createCookie('COUNTRY_REDIRECT', countryCode, {path: '/', expires: 365})
    },

    denySiteCountryRedirect($modal) {
        cookie.createCookie('REDIRECT_DENIED', 'true', {path: '/'});
        $modal.modal('hide');
    }
};

$(() => {
    countryRedirect.init();
});

export default countryRedirect;